import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import audit from './audit'
import finance from './finance'
import approvals from './approvals'
import catalog from './catalog'
import classifieds from './classifieds'
import listings from './listings'
import reviews from './reviews'
import leads from './leads'
import marketing from './marketing'
import users from './users'
import advertisers from './advertisers'
import ai from './ai'
import system from './system'
/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/admin',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\OverviewController::home
* @see app/Http/Controllers/Admin/OverviewController.php:20
* @route '/admin'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

const admin = {
    home: Object.assign(home, home),
    audit: Object.assign(audit, audit),
    finance: Object.assign(finance, finance),
    approvals: Object.assign(approvals, approvals),
    catalog: Object.assign(catalog, catalog),
    classifieds: Object.assign(classifieds, classifieds),
    listings: Object.assign(listings, listings),
    reviews: Object.assign(reviews, reviews),
    leads: Object.assign(leads, leads),
    marketing: Object.assign(marketing, marketing),
    users: Object.assign(users, users),
    advertisers: Object.assign(advertisers, advertisers),
    ai: Object.assign(ai, ai),
    system: Object.assign(system, system),
}

export default admin